<template>
  <div>
    <PageHeading title="Picking dos pedidos" :pieces="['Picking']" />

    <div class="row">
      <div class="col-lg-12">
        <div class="wrapper wrapper-content">
          <div v-if="orders.length === 0" style="padding: 20px">
            <h3 style="text-align: center">Nenhum pedido para picking ;)</h3>
          </div>
          <div
            v-for="order in orders"
            :key="order.id"
            class="ibox"
            :class="{ 'in-attendance': order.inAttendance }"
            style="width: 100%"
          >
            <div
              class="ibox-title"
              style="
                display: flex;
                align-items: center;
                padding: 0;
                padding: 10px;
                justify-content: flex-start;
              "
            >
              <div style="width: 40px">
                <a
                  :title="`Entrar em contato com o cliente no número ${order.customer.id}`"
                  target="_blank"
                  :href="
                    order.origin === 'telegram'
                      ? `https://t.me/${order.customer.id}`
                      : `https://api.whatsapp.com/send?phone=${order.customer.id}`
                  "
                >
                  <img
                    style="width: 100%"
                    :src="
                      order.origin === 'telegram'
                        ? require('@/assets/admin/img/telegram-logo.png')
                        : require('@/assets/admin/img/whatsapp-icon.png')
                    "
                    alt="Falar com cliente"
                  />
                </a>
              </div>
              <span style="padding-left: 10px; color: #000">
                {{ order.createdAt.toDate().toLocaleString() }} | Pedido:
                {{ order.id.substring(0, 10) }} | Cliente:
                {{ order.customer.name }}
              </span>


              <span
                v-if="order.inAttendance"
                style="color: #000; margin-left: 5px"
              >
                // Atendimento iniciado por:
                <strong>{{ order.picker.name }}</strong></span
              >

              <span style="flex: 1"></span>
              <a class="collapse-link" style="margin-right: 3px">
                <button type="submit" class="btn btn-success">
                  <i class="fa fa-list"></i>
                  Ver Lista
                </button>
              </a>

              <button
                @click="markAttendance(order)"
                :disabled="order.inAttendance"
                class="btn btn-primary"
                style="margin-right: 3px"
              >
                Iniciar atendimento
              </button>

              <button
                @click="archiveOrder(order)"
                class="btn btn-danger"
              >
                Arquivar pedido
              </button>
            </div>
            <div style="padding: 10px; background: #fff; color:#000;">
              Endereço: {{ order.customer.address }}, {{ order.customer.address_number }} - {{ order.customer.district }} <span v-if="order.customer.address_complement">, {{ order.customer.address_complement }}</span> | Forma de pagamento: {{ order.paymentMethod }}
            </div>

            <div class="ibox-content" style="display: none">
              <ul class="todo-list m-t small-list" style="margin-bottom: 20px">
                <li
                  v-for="(item, index) in order.items"
                  :key="index"
                  @click="toggleCheck(order, index)"
                  style="display: flex; align-items: center; cursor: pointer"
                >
                  <a href="javascript:void(0)" class="check-link">
                    <i
                      style="font-size: 1.5em"
                      :class="{
                        'fa fa-square-o': !item.checked,
                        'fa fa-check-square': item.checked,
                      }"
                    ></i>
                  </a>
                  <span
                    class="m-l-xs"
                    style="font-size: 1.5em"
                    :class="{ 'todo-completed': item.checked }"
                    >{{ item.qty }} X {{ item.descricao }} ........ (
                    {{ (item.qty * item.price) | currency }} )</span
                  >
                </li>
              </ul>

              <p>
                Taxa administrativa:
                {{ order.amount.taxes.administrative | currency }}
              </p>
              <p>
                Taxa cobrada pela distância ({{
                  order.supermarket.distance.toFixed(2)
                }}Km): {{ order.amount.taxes.distance | currency }}
              </p>
              <p>
                Valor dos itens: {{ order.amount.itemsAmount | currency }}
                <strong>({{ itemsAmount | currency }})</strong>
              </p>
              <p>
                Valor total: {{ order.amount.orderAmount | currency }}
                <strong
                  >({{
                    (itemsAmount +
                      order.amount.taxes.distance +
                      order.amount.taxes.administrative)
                      | currency
                  }})</strong
                >
              </p>

              <hr />

              <button
                @click="doRegister(order)"
                :disabled="
                  order.items.filter((item) => item.checked).length === 0
                "
                class="btn btn-primary"
              >
                Concluir lista
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import PageHeading from "@/views/admin/components/PageHeading.vue";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeading,
  },

  computed: {
    ...mapGetters(["authUser", "userData"]),
  },

  methods: {
    async archiveOrder(order) {
      if(confirm('Tem certeza de que deseja arquivar o pedido? Essa ação não pode ser desfeita.')) {
        const ordersCollection = firebase.firestore().collection("orders");
        const orderDoc = ordersCollection.doc(order.id);
        try {
          await orderDoc.update({status: 'archived'});
          alert('Pedido arquivado com sucesso');
        } catch (e) {
          alert('Erro ao arquivar o pedido.');
        }
      }
    },
    async doRegister(order) {
      try {
        const checkedItems = order.items.filter((item) => item.checked);
        const itemsAmount = [...checkedItems]
          .map((item) => item.qty * item.price)
          .reduce((acc, cur) => acc + cur);
        const orderAmount =
          order.amount.taxes.administrative +
          order.amount.taxes.distance +
          itemsAmount;
        await order.reference.update({
          status: "done",
          items: checkedItems,
          amount: Object.assign(order.amount, {
            itemsAmount,
            orderAmount,
          }),
          inAttendance: firebase.firestore.FieldValue.delete(),
        });
        alert("Picking do pedido concluído com sucesso.");
        this.$data.iAmPicking = false;
      } catch (e) {
        console.log(e);
        alert(
          "Houve um erro ao concluir o picking! Atualize a página e tente novamente."
        );
        this.$data.iAmPicking = false;
      }
    },

    toggleCheck(order, index) {
      if (
        this.$data.iAmPicking &&
        (!order.picker || order.picker.id !== this.userData.id)
      ) {
        alert(
          "Não é possível dar check nos itens deste pedido pois você já tem um pedido em atendimento. Termine o pedido atual para poder atender outro."
        );
        return;
      }

      if (
        typeof order.picker !== "undefined" &&
        order.picker.id !== this.userData.id
      ) {
        alert("Esse pedido já está em atendimento por outro operador");
        return;
      }

      if (!order.picker) {
        alert(
          'Para fazer check dos itens é preciso marcar o pedido como em atendimento clicando no botão "Atender Cliente"'
        );
        return;
      }

      order.items[index].checked = !order.items[index].checked;
      const checkedItems = order.items.filter((item) => item.checked);
      this.$data.itemsAmount = [...checkedItems]
        .map((item) => item.qty * item.price)
        .reduce((acc, cur) => acc + cur, 0);
    },

    async markAttendance(order) {
      if (this.$data.iAmPicking) {
        alert(
          "Não é possível atender outro pedido. Você já está em atendimento de um pedido."
        );
        return;
      }
      if (order.picker && order.picker.id !== this.userData.id) {
        alert(
          "Não é possível atender este pedido pois ele está em atendimento por outro usuário."
        );
        return;
      }

      if (this.userData) {
        try {
          await order.reference.update({
            inAttendance: true,
            updatedAt: new Date(),
            picker: {
              cpf: this.userData.cpf || null,
              email: this.userData.email,
              id: this.userData.id,
              name: this.userData.name || this.userData.tradeName,
            },
          });
        } catch (e) {
          alert(
            "Houve um erro inesperado ao marcar pedido como EM ATENDIMENTO. Atualize a página e tente novamente."
          );
          this.$data.iAmPicking = false;
        }
      }
    },

    fetchOrders() {
      if (this.$data.subscription) this.$data.subscription();
      let supermarketId = null;
      supermarketId =
        this.userData.type == "picker"
          ? this.userData.supermarket.id
          : this.userData.id;
      // TODO: Adicionar caso do usuário picker
      this.$data.subscription = firebase
        .firestore()
        .collection("orders")
        .where("status", "==", "created")
        .where("supermarket.id", "==", supermarketId)
        .onSnapshot((querySnapshot) => {
          this.$data.orders = [];
          querySnapshot.docs.forEach((docSnapshot) => {
            let data = docSnapshot.data();
            if (data.picker && data.picker.email != this.userData.email) return;
            // if(data.inAttendance && data.picker && data.picker.email != this.userData.email)
            data.items.forEach((item) => (item.checked = false));
            if (!this.$data.iAmPicking)
              this.$data.iAmPicking = data.picker?.id === this.userData.id;
            this.$data.orders.push({
              id: docSnapshot.id,
              ...data,
              reference: docSnapshot.ref,
            });
          });
        });
    },
  },

  data() {
    return {
      subscription: null,
      orders: [],
      iAmPicking: false,
      attendance: null,
      itemsAmount: 0,
    };
  },

  created() {
    this.fetchOrders();
    $("body").on("click", ".collapse-link", function () {
      var ibox = $(this).closest("div.ibox");
      var button = $(this).find("i");
      var content = ibox.find("div.ibox-content");
      content.slideToggle(200);
      button.toggleClass("fa-chevron-up").toggleClass("fa-chevron-down");
      ibox.toggleClass("").toggleClass("border-bottom");
      setTimeout(function () {
        ibox.resize();
        ibox.find("[id^=map-]").resize();
      }, 50);
    });
  },

  mounted() {},

  destroyed() {
    if (this.$data.subscription) this.$data.subscription();
  },
};
</script>

<style lang="scss" scoped>
.in-attendance {
  background-color: #ffffbe;

  .ibox-title {
    background-color: transparent;
  }
}
</style>